import React from 'react';
import {useIntl} from "umi";
import {Radio} from 'tea-component';

interface Props {
  timeType?: 'Day' | 'Week' | 'Month'
  onChange: (value:string) => void
  value: ShowValueType
  isShowSdlw: boolean
  isShowDod: boolean
  isShowChange?: boolean
  className?: string
}

export type ShowValueType = 'value_only' | 'dod' | 'sdlw'

export default function SelectShowValueType(props: Props) {
  const {
    value,
    timeType = 'Day',
    onChange,
    isShowSdlw,
    isShowDod,
    isShowChange,
    className,
  } = props
  const { formatMessage } = useIntl();

  const handleChange = (value) => {
    onChange?.(value)
  }

  return (
      <Radio.Group value={value} onChange={handleChange} className={`show-value-type ${className}`}>
        <Radio name="value_only">{formatMessage({id: "common_value_only"})}</Radio>
        {isShowDod && (<Radio name="dod">{formatMessage({id: `common_show_dod_${timeType}`})}</Radio>)}
        {isShowSdlw && (<Radio name="sdlw">{formatMessage({id: `common_show_sdlw_${timeType}`})}</Radio>)}
        {isShowChange && (<Radio name="change">{formatMessage({id: 'common_options_show_change'})}</Radio>)}
      </Radio.Group>
  );
}
